import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { TagsService } from '../services/TagsService';
import { container } from 'tsyringe';

export const deleteTagUseCase = async (tagId: string, currentUser: CurrentUser): Promise<void> => {
  await container.resolve<TagsService>('TagsService').deleteTag(tagId, currentUser);
};
